<form #form="ngForm" novalidate>
  <div class="gdpr-container">
    <label class="m-label">Trattativa dati personali</label>
    <div class="gdpr" [innerHtml]="'gdpr.text' | translate">
    </div>
  </div>
</form>